module.exports = __webpack_public_path__ + "static/img/CHARLIE-BANFIELD.9f585f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CHARLIE-BANFIELD.jpg
// module id = 0lLN
// module chunks = 0